var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "ul",
      {
        attrs: { id: "tlyPageGuide", "data-tourtitle": "Searching the corpus" },
      },
      [
        _c(
          "li",
          {
            staticClass: "tlypageguide_top",
            attrs: { "data-tourtarget": "a[href='#simple']" },
          },
          [
            _c("p", [_vm._v("The "), _c("code", [_vm._v("simple")])]),
            _vm._v(" search lets you quickly search for words. It supports "),
            _c("code", [_vm._v("wildcards")]),
            _vm._v("."),
            _c("br"),
            _vm._v(" "),
            _c("code", [_vm._v("Wildcards")]),
            _vm._v(
              " are special characters that will match any other character. Two kinds of wildcards are supported:"
            ),
            _c("br"),
            _vm._v("\n\t\tThe "),
            _c("code", [_vm._v("*")]),
            _vm._v(" wildcard will match any string, of any length."),
            _c("br"),
            _vm._v("\n\t\tThe "),
            _c("code", [_vm._v("?")]),
            _vm._v(" wildcard will match any single letter or character."),
            _c("br"),
            _vm._v("\n\t\tAs an example: searching for "),
            _c("code", [_vm._v("a*b")]),
            _vm._v(" will match "),
            _c("i", [_vm._v("all values")]),
            _vm._v(" that start with "),
            _c("code", [_vm._v("a")]),
            _vm._v(" and end with "),
            _c("code", [_vm._v("b")]),
            _vm._v(",\n\t\twhile searching for "),
            _c("code", [_vm._v("a?b")]),
            _vm._v(" will match match "),
            _c("i", [_vm._v("only three-letter values")]),
            _vm._v(" starting with "),
            _c("code", [_vm._v("a")]),
            _vm._v(" and ending with "),
            _c("code", [_vm._v("b")]),
            _vm._v("."),
            _c("br"),
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass: "tlypageguide_top",
            attrs: { "data-tourtarget": "a[href='#extended']" },
          },
          [
            _c("div", [
              _c("p", [
                _vm._v("\n\t\t\t\tThe "),
                _c("code", [_vm._v("extended")]),
                _vm._v(
                  " search allows you to quickly find all occurrences of "
                ),
                _c("code", [_vm._v("tokens")]),
                _vm._v(" with specific "),
                _c("code", [_vm._v("attributes")]),
                _vm._v(" in this corpus."),
                _c("br"),
              ]),
              _vm._v(" "),
              _c("p", [
                _c("code", [_vm._v("Tokens")]),
                _vm._v(
                  " are the smallest unit within a corpus, usually just a single word."
                ),
                _c("br"),
                _vm._v(" "),
                _c("code", [_vm._v("Attributes")]),
                _vm._v(" are the different values that together make up a "),
                _c("code", [_vm._v("token")]),
                _vm._v("."),
                _c("br"),
                _vm._v("\n\t\t\t\tThe most commonly available attributes are "),
                _c("code", [_vm._v("Lemma")]),
                _vm._v(", "),
                _c("code", [_vm._v("Part of Speech")]),
                _vm._v(" and "),
                _c("code", [_vm._v("Word")]),
                _vm._v(
                  ",\n\t\t\t\thowever this can differ on a corpus by corpus basis."
                ),
                _c("br"),
                _vm._v(
                  "\n\t\t\t\tAll supported attributes for this corpus will be shown here."
                ),
                _c("br"),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n\t\t\t\tEnter the value you want to find tokens for in any of the inputs below."
                ),
                _c("br"),
                _vm._v(
                  "\n\t\t\t\tPress enter or click the search button below to execute the search and view the results."
                ),
                _c("br"),
                _vm._v("\n\t\t\t\tAs an example: to find all "),
                _c("code", [_vm._v("nouns")]),
                _vm._v(" within this corpus (assuming this corpus supports "),
                _c("code", [_vm._v("part of speech")]),
                _vm._v(" tags),\n\t\t\t\tenter "),
                _c("code", [_vm._v("NOU")]),
                _vm._v(
                  " (or the equivalent tag for a noun in this corpus) in the "
                ),
                _c("code", [_vm._v("part of speech")]),
                _vm._v(" field."),
                _c("br"),
                _vm._v(
                  '\n\t\t\t\tTo find all occurrences of the word "ship", enter '
                ),
                _c("code", [_vm._v("ship")]),
                _vm._v(" in the "),
                _c("code", [_vm._v("lemma")]),
                _vm._v(" field."),
                _c("br"),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v("\n\t\t\t\tLike the "),
                _c("code", [_vm._v("simple")]),
                _vm._v(" search, it supports "),
                _c("code", [_vm._v("Wildcards")]),
                _vm._v("."),
                _c("br"),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v("\n\t\t\t\tIt's also possible to search for series of "),
                _c("code", [_vm._v("tokens")]),
                _vm._v(", such as a "),
                _c("code", [_vm._v("verb")]),
                _vm._v(" followed by a "),
                _c("code", [_vm._v("noun")]),
                _vm._v("."),
                _c("br"),
                _vm._v(
                  "\n\t\t\t\tTo do this, enter multiple values in any of the fields, each value separated by a space."
                ),
                _c("br"),
                _vm._v("\n\t\t\t\tAs an example: to find all instances of an "),
                _c("code", [_vm._v("adjective")]),
                _vm._v(" followed by a "),
                _c("code", [_vm._v("noun")]),
                _vm._v(" (assuming this corpus contains "),
                _c("code", [_vm._v("part of speech")]),
                _vm._v(" tags),"),
                _c("br"),
                _vm._v("\n\t\t\t\tenter "),
                _c("code", [_vm._v("ADJ NOU")]),
                _vm._v(" (or the equivalent names for this corpus) in the "),
                _c("code", [_vm._v("part of speech")]),
                _vm._v(" field."),
                _c("br"),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n\t\t\t\tValues at the same position in different fields are grouped together as a single "
                ),
                _c("code", [_vm._v("token")]),
                _vm._v(
                  ", meaning that all values in the first position of each field are grouped to match a single "
                ),
                _c("code", [_vm._v("token")]),
                _vm._v(
                  ",\n\t\t\t\tlikewise for the second values in every field, and so on."
                ),
                _c("br"),
                _vm._v("\n\t\t\t\tAs an example: searching for "),
                _c("code", [_vm._v("part of speech")]),
                _vm._v(" "),
                _c("code", [_vm._v("NOU")]),
                _vm._v(" together with "),
                _c("code", [_vm._v("lemma")]),
                _vm._v(" "),
                _c("code", [_vm._v("a*")]),
                _vm._v("\n\t\t\t\twill find all "),
                _c("code", [_vm._v("nouns")]),
                _vm._v(" starting with the letter "),
                _c("code", [_vm._v("a")]),
                _vm._v(" as you would expect, while searching for "),
                _c("code", [_vm._v("pos")]),
                _vm._v(" "),
                _c("code", [_vm._v("ADJ NOU")]),
                _vm._v(" together with "),
                _c("code", [_vm._v("lemma")]),
                _vm._v(" "),
                _c("code", [_vm._v("a* b*")]),
                _vm._v("\n\t\t\t\twill find all "),
                _c("code", [_vm._v("adjectives")]),
                _vm._v(" starting with the letter "),
                _c("code", [_vm._v("a")]),
                _vm._v(", "),
                _c("i", [_vm._v("followed by")]),
                _vm._v(" a "),
                _c("code", [_vm._v("noun")]),
                _vm._v(" starting with the letter "),
                _c("code", [_vm._v("b")]),
                _vm._v("."),
                _c("br"),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass: "tlypageguide_bottom",
            attrs: { "data-tourtarget": "#extended_split_batch" },
          },
          [
            _c("div", [
              _c("p", [
                _vm._v(
                  "\n\t\t\t\tSplit your query into many smaller queries.\n\t\t\t"
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v("\n\t\t\t\tValues for all "),
                _c("code", [_vm._v("attributes")]),
                _vm._v(" are split on "),
                _c("code", [_vm._v("OR")]),
                _vm._v(" (the "),
                _c("code", [_vm._v("|")]),
                _vm._v(
                  " character), and every term is executed as a separate query."
                ),
                _c("br"),
                _vm._v("\n\t\t\t\tEntered "),
                _c("code", [_vm._v("Metadata filters")]),
                _vm._v(" will apply to all subqueries.\n\t\t\t"),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n\t\t\t\tAfter running the query, the result of the last value will be shown."
                ),
                _c("br"),
                _vm._v(
                  "\n\t\t\t\tThe other subqueries can be inspected and loaded from the "
                ),
                _c("code", [_vm._v("history")]),
                _vm._v(" panel.\n\t\t\t"),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass: "tlypageguide_left",
            attrs: { "data-tourtarget": ".propertyfield .file-input-button" },
          },
          [
            _c("div", [
              _vm._v(
                "\n\t\t\tClick here to upload a list of values to search for."
              ),
              _c("br"),
              _vm._v(
                "\n\t\t\tEvery word in the file will be added to the list of values to search for."
              ),
              _c("br"),
              _vm._v(
                "\n\t\t\tTo remove the wordlist, click the button again, then press "
              ),
              _c("code", [_vm._v("cancel")]),
              _vm._v(
                " when presented with the file selection (only works in chrome),\n\t\t\tor simply delete all text in the field.\n\t\t"
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass: "tlypageguide_top",
            attrs: { "data-tourtarget": "a[href='#advanced']" },
          },
          [
            _c("div", [
              _c("p", [
                _vm._v("\n\t\t\t\tThis is the "),
                _c("code", [_vm._v("querybuilder")]),
                _vm._v(
                  ". With it, you can create complex queries without writing CQL."
                ),
                _c("br"),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n\t\t\t\tThe querybuilder is structured around configuring the "
                ),
                _c("code", [_vm._v("attributes")]),
                _vm._v(" of "),
                _c("code", [_vm._v("tokens")]),
                _vm._v("."),
                _c("br"),
                _vm._v(
                  "\n\t\t\t\tCreate one or more tokens, and fill in which attributes a token must have to be found."
                ),
                _c("br"),
                _vm._v(
                  "\n\t\t\t\tIn addition to the simple search, it's also possible to define specific combinations of attributes, or specify lists of possible attributes, and more.\n\t\t\t"
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n\t\t\t\tWhen multiple tokens are used, they are matched in order from left to right."
                ),
                _c("br"),
                _vm._v(
                  "\n\t\t\t\tAny time a query is created in the querybuilder, it's also copied to the "
                ),
                _c("code", [_vm._v("CQL editor")]),
                _vm._v(
                  ", where you can further edit the query by hand.\n\t\t\t"
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass: "tlypageguide_top",
            attrs: { "data-tourtarget": ".bl-token .panel-heading" },
          },
          [
            _c("div", [
              _c("p", [
                _vm._v("\n\t\t\t\tThis is a "),
                _c("code", [_vm._v("token")]),
                _vm._v(", the basic building block of a query."),
                _c("br"),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n\t\t\t\tA token in the querybuilder is made up two parts:"
                ),
                _c("br"),
                _vm._v("\n\t\t\t\tThe set of "),
                _c("code", [_vm._v("attributes")]),
                _vm._v(
                  " a token in the corpus must have to be matched by the query."
                ),
                _c("br"),
                _vm._v(
                  "\n\t\t\t\tCreate attributes by clicking the + button within this token. Then enter a value that the attribute must have for the token to be found."
                ),
                _c("br"),
                _vm._v("\n\t\t\t\tContextual "),
                _c("code", [_vm._v("properties")]),
                _vm._v(", such as whether the "),
                _c("code", [_vm._v("token")]),
                _vm._v(
                  " occurs at the start, or the end of a sentence.\n\t\t\t"
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n\t\t\t\tThe CQL query generated to match this token in the corpus is also displayed here, to help understand what is happening internally."
                ),
                _c("br"),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n\t\t\t\tRearrange a token by clicking and dragging the little arrow handle in the top-left corner."
                ),
                _c("br"),
                _vm._v(
                  "\n\t\t\t\tDelete a token by clicking the x in the top-right corner."
                ),
                _c("br"),
                _vm._v(
                  "\n\t\t\t\tCreate new tokens by clicking the + button over on the right."
                ),
                _c("br"),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass: "tlypageguide_top",
            attrs: { "data-tourtarget": ".bl-token-create" },
          },
          [
            _c("div", [
              _vm._v(
                "\n\t\t\tCreate additional tokens by clicking this button.\n\t\t"
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass: "tlypageguide_right",
            attrs: { "data-tourtarget": ".bl-token-attribute" },
          },
          [
            _c("div", [
              _c("p", [
                _vm._v("\n\t\t\t\tThis is an "),
                _c("code", [_vm._v("attribute")]),
                _vm._v(" of this token."),
                _c("br"),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v("\n\t\t\t\tAttributes are much like in the "),
                _c("code", [_vm._v("simple")]),
                _vm._v(
                  " search. Select which attribute\n\t\t\t\ta token should have, and enter the value that the attribute must have for the token to be matched."
                ),
                _c("br"),
                _vm._v(
                  "\n\t\t\t\tIn addition to this simple behavior the querybuilder also allows several more advanced configurations."
                ),
                _c("br"),
                _vm._v(
                  "\n\t\t\t\tAttributes in the querybuilder are interpreted as "
                ),
                _c("code", [_vm._v("regular expressions")]),
                _vm._v(".\n\t\t\t"),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n\t\t\t\tUsing the + buttons, new attributes can be added. Two options exist: "
                ),
                _c("code", [_vm._v("AND")]),
                _vm._v(" and "),
                _c("code", [_vm._v("OR")]),
                _vm._v("."),
                _c("br"),
                _vm._v("\n\t\t\t\tThe "),
                _c("code", [_vm._v("AND")]),
                _vm._v(" option creates a new attribute that "),
                _c("i", [_vm._v("also")]),
                _vm._v(" must exist on a token for that token to be matched."),
                _c("br"),
                _vm._v("\n\t\t\t\tAs an example: the attribute "),
                _c("code", [_vm._v("part of speech")]),
                _vm._v(" with value "),
                _c("code", [_vm._v("NOU")]),
                _vm._v(
                  " is already defined, so all tokens that are nouns will be matched."
                ),
                _c("br"),
                _vm._v("\n\t\t\t\tCreating a new attribute using "),
                _c("code", [_vm._v("AND")]),
                _vm._v(
                  " will change that query so that now a token must be a noun, "
                ),
                _c("i", [_vm._v("in addition")]),
                _vm._v(" to being/having whatever new attribute is created."),
                _c("br"),
                _vm._v("\n\t\t\t\tThe "),
                _c("code", [_vm._v("OR")]),
                _vm._v(
                  " largely performs the same role, with the change that a token will now be matched whenever it has the original attribute "
                ),
                _c("i", [_vm._v("or")]),
                _vm._v(" the new attribute."),
                _c("br"),
                _vm._v("\n\t\t\t\tAs an example: you have an attribute "),
                _c("code", [_vm._v('lemma = "bee"')]),
                _vm._v(", and you select "),
                _c("code", [_vm._v("AND")]),
                _vm._v("."),
                _c("br"),
                _vm._v("\n\t\t\t\tNow you have "),
                _c("code", [_vm._v('lemma = "bee"')]),
                _vm._v(" AND "),
                _c("code", [_vm._v("some other attribute")]),
                _vm._v(
                  ", and both of these must be true for a token to be found."
                ),
                _c("br"),
                _vm._v("\n\t\t\t\tIf you had selected "),
                _c("code", [_vm._v("OR")]),
                _vm._v(" it would find all tokens with either "),
                _c("code", [_vm._v('lemma = "bee"')]),
                _vm._v(" or that have your new attribute"),
                _c("br"),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n\t\t\t\tIt's also possible to upload a list of values, to do so, click the upload button that appears when you hover the mouse over the text input for this attribute and select a text file.\n\t\t\t\tTokens will then be matched for any of the values from the file."
                ),
                _c("br"),
                _vm._v(
                  "\n\t\t\t\tUploaded files must be be plain text files (.txt), with each value on its own line."
                ),
                _c("br"),
                _vm._v(
                  "\n\t\t\t\tAfter uploading a file, the text can be edited by clicking the yellow button that has appeared in place of the text field. Editing the text is temporary and will not modify your original file."
                ),
                _c("br"),
                _vm._v(
                  "\n\t\t\t\tTo remove an uploaded file and go back to typing a value, click the upload button a second time, then press cancel instead of selecting a file.\n\t\t\t"
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass: "tlypageguide_top",
            attrs: { "data-tourtarget": "a[href='#expert']" },
          },
          [
            _c("div", [
              _c("p", [
                _vm._v("\n\t\t\t\tThe "),
                _c("code", [_vm._v("CQL editor")]),
                _vm._v(
                  " allows you to type your own CQL query, or edit a query further after creating it in the "
                ),
                _c("code", [_vm._v("querybuilder")]),
                _vm._v(".\n\t\t\t"),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v("\n\t\t\t\tQueries generated by the "),
                _c("code", [_vm._v("querybuilder")]),
                _vm._v(
                  " will be pasted here automatically. Note that this will overwrite any queries you type here yourself!"
                ),
                _c("br"),
                _vm._v(
                  "\n\t\t\t\tIn some cases, when the query is relatively simple, it can be also be imported into the querybuilder using the "
                ),
                _c("code", [_vm._v("copy to query builder")]),
                _vm._v(
                  " button below.\n\t\t\t\tA message will be displayed next to the button if the query couldn't be parsed.\n\t\t\t"
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v("\n\t\t\t\tFor more information on how to write "),
                _c("code", [_vm._v("CQL")]),
                _vm._v(", "),
                _c(
                  "a",
                  {
                    staticStyle: {
                      "text-decoration": "underline",
                      color: "#337ab7",
                    },
                    attrs: {
                      target: "_blank",
                      href: "https://github.com/INL/BlackLab/blob/d20eb71b25137facf10f7d2681242de34ab1fa54/core/src/site/markdown/corpus-query-language.md",
                    },
                  },
                  [_vm._v("click here")]
                ),
                _vm._v(".\n\t\t\t"),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass: "tlypageguide_bottom",
            attrs: { "data-tourtarget": "#gapFilling" },
          },
          [
            _c("div", [
              _c("p", [
                _vm._v(
                  "\n\t\t\t\tUse this button to upload a TSV file with terms to complete a query with marked gaps."
                ),
                _c("br"),
                _vm._v("\n\t\t\t\tFor instance, given a query:"),
                _c("br"),
                _vm._v(" "),
                _c("code", [_vm._v('[lemma="@@"][pos="LID.*"][lemma="@@"]')]),
                _c("br"),
                _vm._v(
                  "\n\t\t\t\tyou would supply a list with two tab-separated columns of terms, where the terms in the first column will be entered at the position of the first gap (@@) and the words in the second column at the position of the second gap.\n\t\t\t\tThis mimics the word list functionality of the Extended and Advanced search interfaces.\n\t\t\t"
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n\t\t\t\tPlease note that for this to work, you do need to enter @@ in the field where you want the substitution to take place. An empty field ([]) will match any term.\n\t\t\t"
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass: "tlypageguide_bottom",
            attrs: { "data-tourtarget": "#importQuery" },
          },
          [
            _c("div", [
              _c("p", [
                _vm._v(
                  "\n\t\t\t\tImport previously saved queries here.\n\t\t\t"
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v("\n\t\t\t\tTo "),
                _c("code", [_vm._v("export")]),
                _vm._v(
                  " a query: first run a search, then open the history, and select "
                ),
                _c("code", [_vm._v("save as file")]),
                _vm._v(" in the dropdown on the right.\n\t\t\t"),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass: "tlypageguide_top",
            attrs: { "data-tourtarget": "#filterContainer" },
          },
          [
            _c("div", [
              _c("p", [
                _vm._v("\n\t\t\t\tListed here are the "),
                _c("code", [_vm._v("metadata")]),
                _vm._v(" fields that exist on documents within this corpus."),
                _c("br"),
                _vm._v(
                  "\n\t\t\t\tUsing these fields a query can be limited to a subset of documents with specific metadata values."
                ),
                _c("br"),
                _vm._v(
                  "\n\t\t\t\tIt's also possible to view all documents by leaving all "
                ),
                _c("code", [_vm._v("attributes")]),
                _vm._v(" in the "),
                _c("code", [_vm._v("simple")]),
                _vm._v(" search empty.\n\t\t\t"),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n\t\t\t\tAs an example: to search within only documents from the year "
                ),
                _c("code", [_vm._v("2003")]),
                _vm._v(
                  " (assuming documents contain metadata for the year of writing),"
                ),
                _c("br"),
                _vm._v("\n\t\t\t\ttype "),
                _c("code", [_vm._v("2003")]),
                _vm._v(" in the "),
                _c("code", [_vm._v("year")]),
                _vm._v(
                  " field (or the equivalent name of the year data in this corpus)."
                ),
                _c("br"),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n\t\t\t\tSome values like dates and numbers support entering a "
                ),
                _c("code", [_vm._v("range")]),
                _vm._v("."),
                _c("br"),
                _vm._v("\n\t\t\t\tRanges are "),
                _c("code", [_vm._v("inclusive")]),
                _vm._v(", meaning that for a range of "),
                _c("code", [_vm._v("10 to 20")]),
                _vm._v(
                  ", documents for which the value is exactly 10 or 20 will also be included.\n\t\t\t"
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n\t\t\t\tSome of the most common values will for each field be autocompleted as you are entering a value. Clicking on an autocompleted value will paste that value in the field."
                ),
                _c("br"),
                _vm._v(
                  "\n\t\t\t\tFor fields where the total number of different values is relatively small, a dropdown will be shown instead, allowing you to pick the exact set of documents to search."
                ),
                _c("br"),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n\t\t\t\tTo search in documents within a set of different values, enter multiple values, separated by spaces. If one of the values already contains spaces of itself, it must be surrounded by double quotes ("
                ),
                _c("code", [_vm._v('"')]),
                _vm._v(")."),
                _c("br"),
                _vm._v("\n\t\t\t\tAs an example: to match the value "),
                _c("code", [_vm._v("my metadata value")]),
                _vm._v(", enter "),
                _c("code", [_vm._v('"my metadata value"')]),
                _vm._v(" in the field, including the quotes."),
                _c("br"),
                _vm._v("\n\t\t\t\tEntering "),
                _c("code", [_vm._v("three different values")]),
                _vm._v(
                  " without quotes will instead search in any document with a value of "
                ),
                _c("code", [_vm._v("three")]),
                _vm._v(", "),
                _c("code", [_vm._v("different")]),
                _vm._v(" or "),
                _c("code", [_vm._v("values")]),
                _vm._v(" for that metadata field.\n\t\t\t"),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass: "tlypageguide_top",
            attrs: { "data-tourtarget": "#resultTabs" },
          },
          [
            _c("div", [
              _vm._v(
                "\n\t\t\tResults can be viewed in two ways: as individual "
              ),
              _c("code", [_vm._v("hits")]),
              _vm._v(" (groups of one or more "),
              _c("code", [_vm._v("tokens")]),
              _vm._v(" that matched the query),\n\t\t\tor as the "),
              _c("code", [_vm._v("documents")]),
              _vm._v(" in which those hits exist."),
              _c("br"),
              _vm._v(
                "\n\t\t\tHits are only available when the query matches at least one attribute.\n\t\t"
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass: "tlypageguide_top",
            attrs: { "data-tourtarget": ".results-table th .dropdown" },
          },
          [
            _c("div", [
              _vm._v(
                "\n\t\t\tClick on any of the column headings to sort the "
              ),
              _c("code", [_vm._v("hits")]),
              _vm._v(
                " on values within the column, clicking again inverts the sorting.\n\t\t"
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass: "tlypageguide_top",
            attrs: { "data-tourtarget": ".doctitle a" },
          },
          [
            _c("div", [
              _c("p", [
                _c("code", [_vm._v("Hit")]),
                _vm._v(" rows are always preceded by a row containing the "),
                _c("code", [_vm._v("document")]),
                _vm._v(" in which those hits occurred."),
                _c("br"),
                _vm._v(
                  "\n\t\t\t\tHit rows can be toggled on or off using the "
                ),
                _c("code", [_vm._v("Show/hide titles")]),
                _vm._v(" button."),
                _c("br"),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n\t\t\t\tClick the title of this document to open the document in a new window. Hits from the current query will be highlighted in the opened document."
                ),
                _c("br"),
                _vm._v(
                  "\n\t\t\t\tThis functionality is only available when the corpus has not disabled the viewing of documents."
                ),
                _c("br"),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass: "tlypageguide_top",
            attrs: { "data-tourtarget": ".hits-table tr.concordance" },
          },
          [
            _c("div", [
              _vm._v(
                "\n\t\t\tClick a hit to show a part of the document surrounding the hit. Click again to close.\n\t\t"
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass: "tlypageguide_top",
            attrs: { "data-tourtarget": ".groupselect" },
          },
          [
            _c("div", [
              _c("p", [
                _vm._v(
                  "\n\t\t\t\tResults can be grouped by properties of the "
                ),
                _c("code", [_vm._v("tokens")]),
                _vm._v(" or "),
                _c("code", [_vm._v("documents")]),
                _vm._v(" in which those hits occur."),
                _c("br"),
                _vm._v(" "),
                _c("code", [_vm._v("left context")]),
                _vm._v(", "),
                _c("code", [_vm._v("right context")]),
                _vm._v(" and "),
                _c("code", [_vm._v("hit")]),
                _vm._v(" will group the tokens based on the "),
                _c("code", [_vm._v("token's")]),
                _vm._v(" attributes."),
                _c("br"),
                _vm._v("\n\t\t\t\tThe remaining options group by the "),
                _c("code", [_vm._v("metadata")]),
                _vm._v(" of the "),
                _c("code", [_vm._v("documents")]),
                _vm._v(".\n\t\t\t"),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass: "tlypageguide_top",
            attrs: { "data-tourtarget": ".group-size-indicator" },
          },
          [
            _c("div", [
              _vm._v("\n\t\t\tClick a "),
              _c("code", [_vm._v("group")]),
              _vm._v(" to show or hide the "),
              _c("code", [_vm._v("hits")]),
              _vm._v(" within that group.\n\t\t"),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass: "tlypageguide_top",
            attrs: { "data-tourtarget": ".open-concordances" },
          },
          [
            _c("div", [
              _vm._v("\n\t\t\tClick here to go back to the normal "),
              _c("code", [_vm._v("hits")]),
              _vm._v(
                " view to see more detailed information for the hits in this group."
              ),
              _c("br"),
              _vm._v(
                "\n\t\t\tA small indicator will appear to let you know that you're looking at hits from a specific group only.\n\t\t"
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass: "tlypageguide_right",
            attrs: { "data-tourtarget": "tr.document" },
          },
          [
            _c("div", [
              _vm._v("\n\t\t\tInformation about a "),
              _c("code", [_vm._v("document")]),
              _vm._v("."),
              _c("br"),
              _vm._v("\n\t\t\tClick the document's title or the "),
              _c("code", [_vm._v("view document info")]),
              _vm._v(" button to open this document in a new window."),
              _c("br"),
              _vm._v(
                "\n\t\t\tThis functionality is only available when the corpus has not disabled the viewing of documents."
              ),
              _c("br"),
            ]),
          ]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }